import { colors, responsiveUtils, theme } from '@sato/components';
import {
  VictoryStyleObject,
  VictoryTheme,
  VictoryThemeDefinition,
} from 'victory';

const baseLabelStyles: VictoryStyleObject = {
  fontFamily: theme.fontFamily.sans[0],
  fill: colors['black-text'],
};

const isMobile = responsiveUtils.isMobileScreenSize;

const smallFontSize = isMobile ? 16 : 8;

export const warmWaterColor = colors.brand.primary.main;

export const coldWaterColor = colors.brand.interactive.main;

// Theming is bit complicated, some of the styling has to be given directly to components
export const chartTheme = {
  ...VictoryTheme.grayscale,
  chart: {
    padding: {
      top: 24,
      left: 40,
      right: 40,
      bottom: 24,
    },
  },
  axis: {
    ...VictoryTheme.grayscale.axis,
    style: {
      ...VictoryTheme.grayscale.axis?.style,
      axis: {
        stroke: colors.black,
        ...baseLabelStyles,
      },
      tickLabels: {
        ...baseLabelStyles,
        fontSize: smallFontSize,
        fill: colors['black-medium-text'],
      },
      grid: {
        stroke: colors['black-medium'],
        strokeDasharray: '10, 5',
      },
      axisLabel: {
        ...baseLabelStyles,
        angle: 0,
        fontSize: isMobile ? 16 : 10,
      },
    },
  },
  legend: {
    style: {
      labels: {
        ...baseLabelStyles,
        fontSize: isMobile ? 20 : 7,
      },
    },
  },
  line: {
    style: {
      data: {
        stroke: colors.brand.primary.main,
      },
      labels: {
        ...baseLabelStyles,
        fontSize: smallFontSize,
      },
    },
  },
  scatter: {
    style: {
      data: {
        fill: colors.white,
        stroke: colors.brand.primary.main,
        strokeWidth: isMobile ? 3 : 1,
      },
    },
  },
  bar: {
    style: {
      data: {
        width: 6.5,
        border: 1,
      },
    },
  },
} satisfies VictoryThemeDefinition;
